import { ReactComponent as Icon } from "../files/YouTube_full-color_icon_(2017).svg";
import ISVGIconProps from "../ISVGIconProps";

const YoutubeIcon = ({ fill, style = {} }: ISVGIconProps) => {
    return <Icon fill={fill} style={style} />;
};

export default YoutubeIcon;
